export default class CollapsibleFilterGroup {
  constructor(node) {
    this.element = node;
    this.counter = this.element.querySelector(".js-counter");
    this.inputs = Array.from(this.element.querySelectorAll('input[type="checkbox"], input[type="radio"]'));

    this.initialize();
  }

  initialize() {
    this.inputs.forEach((input) => {
      input.addEventListener("change", () => {
        const checkedInputs = this.inputs.filter((input) => input.checked);

        this.element.classList.toggle("is-active", checkedInputs.length > 0);
        this.counter.innerHTML = checkedInputs.length;
      });
    });
  }
}
